import { Map } from 'immutable';

import {
  FETCH_PROGRESS_REPORTS_REQUEST,
  FETCH_PROGRESS_REPORTS_SUCCESS,
  FETCH_PROGRESS_REPORTS_FAILURE,
} from './actions';
import ProgressReport from './model';

import { ApiResponseHelper } from 'omni-common-ui';

export default function progressReportsReducer(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_PROGRESS_REPORTS_REQUEST:
      return state;
    case FETCH_PROGRESS_REPORTS_SUCCESS:
      return onSuccess(state, action);
    case FETCH_PROGRESS_REPORTS_FAILURE:
    default:
      return state;
  }
}

function onSuccess(state, action) {
  let newState = state;
  action.payload.forEach((progressReport, index) => {
    const progressReportModel = ProgressReport.create(Object.assign(
      progressReport, { index }
    ));
    newState = newState.set(progressReportModel.id, progressReportModel);
  });

  return newState;
}

export function updateGroupProgressReportsAttribute(progressReports, action) {
  switch (action.type) {
    case FETCH_PROGRESS_REPORTS_REQUEST:
      return ApiResponseHelper.create({ loading: true });
    case FETCH_PROGRESS_REPORTS_SUCCESS:
      return ApiResponseHelper.create(onSuccess(new Map(), action));
    case FETCH_PROGRESS_REPORTS_FAILURE:
      return ApiResponseHelper.create(action.error);
    default:
      return progressReports;
  }
}



// WEBPACK FOOTER //
// ./data/ProgressReports/reducer.js